import { h } from "preact";
import { useLocationFormStorage } from "./locationFormContext";

export function GuestOverlay() {
  const {
    adults,
    kids,
    dogs,
    setAdults,
    setKids,
    setDogs,
    setShowGuestOverlay,
  } = useLocationFormStorage();

  const resetGuests = () => {
    setAdults(1);
    setKids(0);
    setDogs(0);
  };

  return (
    <div class="absolute top-0 left-0 w-full bg-white rounded-lg p-4 shadow-lg max-h-[500px] z-100">
      <div class="flex flex-col gap-4 h-full">
        <div class="flex justify-between">
          <h3 className="font-bold text-brandcopy-900">
            {global.Translator.trans("locationform.guest_select", {}, "js")}
          </h3>
          <button
            type="button"
            class="text-xs hover:text-brandcopy-900"
            onClick={() => resetGuests()}
          >
            {global.Translator.trans("locationform.guests_reset", {}, "js")}
          </button>
        </div>
        <div class="grid lg:grid-cols-3 gap-4">
          <div class="inputfield col-span-1 md:col-span-1 md:border-r border-gray-300 flex justify-between md:pr-4 md:gap-6">
            <div class="flex flex-col gap-1">
              <span>
                {global.Translator.trans("locationform.adults", {}, "js")}
              </span>
              <span class="text-xs text-gray-500">
                {global.Translator.trans(
                  "locationform.adults_subtext",
                  {},
                  "js"
                )}
              </span>
            </div>

            <div class="quantitystepper">
              <div class="quantitystepper__control" role="group">
                <button
                  type="button"
                  aria-label={global.Translator.trans(
                    "locationform.add_guest",
                    {
                      entity: global.Translator.trans(
                        "locationform.adults",
                        {},
                        "js"
                      ),
                    },
                    "js"
                  )}
                  class="quantitystepper__control-button quantitystepper__control-button--decrease"
                  onClick={() => setAdults(adults === 1 ? 1 : adults - 1)}
                  aria-controls="locationFormAdults"
                >
                  <span aria-hidden="true">−</span>
                </button>

                <div>
                  <input
                    id="locationFormAdults"
                    type="number"
                    class="quantitystepper__control-input"
                    inputmode="decimal"
                    value={adults}
                    onInput={(e) => setAdults(parseInt(e.target.value))}
                  />
                </div>

                <button
                  type="button"
                  aria-label={global.Translator.trans(
                    "locationform.add_guest",
                    {
                      entity: global.Translator.trans(
                        "locationform.adults",
                        {},
                        "js"
                      ),
                    },
                    "js"
                  )}
                  class="quantitystepper__control-button quantitystepper__control-button--increase"
                  onClick={() => setAdults(adults + 1)}
                  aria-controls="locationFormAdults"
                >
                  <span aria-hidden="true">+</span>
                </button>
              </div>
            </div>
          </div>

          <div class="inputfield col-span-1 md:col-span-1 md:border-r border-gray-300 flex justify-between md:pr-4 md:gap-6">
            {" "}
            <div class="flex flex-col gap-1">
              <span>
                {global.Translator.trans("locationform.children", {}, "js")}
              </span>
              <span class="text-xs text-gray-500">
                {global.Translator.trans(
                  "locationform.children_subtext",
                  {},
                  "js"
                )}
              </span>
            </div>
            <div class="quantitystepper">
              <div class="quantitystepper__control" role="group">
                <button
                  type="button"
                  aria-label={global.Translator.trans(
                    "locationform.add_guest",
                    {
                      entity: global.Translator.trans(
                        "locationform.children",
                        {},
                        "js"
                      ),
                    },
                    "js"
                  )}
                  class="quantitystepper__control-button quantitystepper__control-button--decrease"
                  onClick={() => setKids(kids <= 1 ? 0 : kids - 1)}
                  aria-controls="locationFormKids"
                >
                  <span aria-hidden="true">−</span>
                </button>

                <div>
                  <input
                    id="locationFormKids"
                    type="number"
                    class="quantitystepper__control-input"
                    inputmode="decimal"
                    value={kids}
                  />
                </div>

                <button
                  type="button"
                  aria-label={global.Translator.trans(
                    "locationform.add_guest",
                    {
                      entity: global.Translator.trans(
                        "locationform.children",
                        {},
                        "js"
                      ),
                    },
                    "js"
                  )}
                  class="quantitystepper__control-button quantitystepper__control-button--increase"
                  onClick={() => setKids(kids + 1)}
                  aria-controls="locationFormKids"
                >
                  <span aria-hidden="true">+</span>
                </button>
              </div>
            </div>
          </div>

          <div class="inputfield col-span-1 md:col-span-1 flex justify-between md:pr-4 md:gap-6">
            <div class="flex flex-col justify-center gap-2">
              <span>
                <span>
                  {global.Translator.trans("locationform.dogs", {}, "js")}
                </span>
              </span>
            </div>

            <div class="quantitystepper">
              <div class="quantitystepper__control" role="group">
                <button
                  type="button"
                  aria-label={global.Translator.trans(
                    "locationform.remove_guest",
                    {
                      entity: global.Translator.trans(
                        "locationform.dogs",
                        {},
                        "js"
                      ),
                    },
                    "js"
                  )}
                  class="quantitystepper__control-button quantitystepper__control-button--decrease"
                  aria-controls="locationFormDogs"
                  onClick={() => setDogs(dogs <= 1 ? 0 : dogs - 1)}
                >
                  <span aria-hidden="true">−</span>
                </button>

                <div>
                  <input
                    id="locationFormDogs"
                    type="number"
                    class="quantitystepper__control-input"
                    inputmode="decimal"
                    value={dogs}
                  />
                </div>

                <button
                  type="button"
                  aria-label={global.Translator.trans(
                    "locationform.add_guest",
                    {
                      entity: global.Translator.trans(
                        "locationform.dogs",
                        {},
                        "js"
                      ),
                    },
                    "js"
                  )}
                  class="quantitystepper__control-button quantitystepper__control-button--increase"
                  aria-controls="locationFormDogs"
                  onClick={() => setDogs(dogs + 1)}
                >
                  <span aria-hidden="true">+</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="col-span-1 md:col-span-1 flex items-end">
          <button
            type="button"
            class="btn btn--primary"
            onClick={() => setShowGuestOverlay(false)}
          >
            <span>
              {global.Translator.trans("locationform.confirm", {}, "js")}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}
